import React, { useEffect, useState } from 'react';
import { Alert, Button } from 'reactstrap';

import { VERSION } from '../../utils/env';
import getHtmlVersion from './get-html-version';

const reload = () => window.location.reload();

function VersionCheck() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const interval = setInterval(() => {
      if (visible) return;
      getHtmlVersion().then(domVersion => {
        setVisible(domVersion !== VERSION);
      });
    }, 5 * 60 * 1000);
    return () => clearInterval(interval);
  });

  return (
    <Alert
      color="warning"
      isOpen={visible}
      className="shadow c-flash-message-center d-flex align-items-center"
    >
      A new version of the Sales Cockpit is available. Please
      <Button color="link" className="p-0 ml-1" onClick={reload}>
        reload
      </Button>
      .
    </Alert>
  );
}

export default VersionCheck;
